import { DataTableColumnDef } from "@/components/molecules";
import { renderColumnHeaderWithTooltip } from "../helpers";
import { VehicleCategoryColumnHeader } from "../common/VehicleCategoryColumnHeader";
import { MyVehicleTableData, VehicleRegistrationStatus } from "./types";

export const myVehiclesColumns: DataTableColumnDef<MyVehicleTableData>[] = [
  {
    header: "Year",
    size: 100,
    accessorKey: "year",
    sortDescFirst: false,
  },
  {
    header: "Make",
    accessorKey: "make",
    cell: (props) => props.row.original.make,
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Model",
    accessorKey: "model",
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Number Plate",
    accessorKey: "registration_number",
    cell: (props) => props.row.original.numberPlate,
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Nickname",
    size: 150,
    id: "identifier",
    accessorKey: "nickname",
    sortDescFirst: false,
  },
  {
    header: "Color",
    id: "color",
    cell: (props) => props.row.original.color,
    size: 150,
  },
  {
    header: renderColumnHeaderWithTooltip("Vehicle Type", "Operator-defined vehicle type used within your own fleet setup", "For internal bookings"),
    id: "vehicleType",
    accessorKey: "vehicleType",
    cell: (props) => props.row.original.vehicleType,
    size: 150,
    // Backend vehicle search only sorts on make/model/registration_number/year/identifier;
    // sorting by a multi-valued type is ill-defined anyway.
    enableSorting: false,
  },
  {
    header: VehicleCategoryColumnHeader,
    id: "vehicleCategory",
    accessorKey: "vehicleCategory",
    size: 175,
    enableSorting: false,
  },
  {
    header: "Assigned Driver",
    id: "driver",
    cell: (props) => props.row.original.driver,
    size: 150,
  },
  {
    header: "Drivers",
    id: "driversCount",
    accessorKey: "driversCount",
    size: 100,
    enableSorting: false,
  },
  {
    header: "Actions",
    id: "actions",
    cell: (props) => props.row.original.actions,
    maxSize: 75,
  },
];

export const statusStyles: Record<VehicleRegistrationStatus, string> = {
  verified: "!border-neutral-mid-gray !bg-neutral-surface-gray",
  expiring: "!border-warning !bg-warning-light hover:!bg-warning-light",
  expired: "!border-danger !bg-danger-light hover:!bg-danger-light",
  unverified: "!border-neutral-mid-gray !bg-neutral-surface-gray",
  unknown: "!border-danger !bg-danger-light hover:!bg-danger-light",
  "missing-details": "!border-danger !bg-danger-light hover:!bg-danger-light",
};
